import { FC, useState } from "react";

import { Button, Modal } from "antd";

import { IExamination } from "@/models/Examination";
import { Examinations } from "@/components";

interface ChoseExaminationProps {
  onChoose: (examination: IExamination) => void;
}

const ChoseExamination: FC<ChoseExaminationProps> = ({ onChoose }) => {
  const [examinationsModal, setExaminationsModal] = useState(false);

  const handleChoose = (examination: IExamination) => {
    setExaminationsModal(false)
    onChoose(examination)
  }

  return (
    <>
      <Button onClick={() => setExaminationsModal(true)}>
        Choose exam
      </Button>
      <Modal
        visible={examinationsModal}
        width="fit-content"
        destroyOnClose
        footer={false}
        onCancel={() => setExaminationsModal(false)}
      >
        <Examinations onChoose={handleChoose} />
      </Modal>
    </>
  );
};

export default ChoseExamination;
